import React from 'react';
import PropTypes from 'prop-types';

import { requestLogin } from '../../services/request-login';
import styles from './styles.scss';

const classNames = require('classnames');

const LoginButton = ({ t }) => {
  return (
    <button
      onClick={requestLogin}
      className={classNames(styles.signUpButton, 'ma-primary-button', 'ma-all-members-buttons-corner-radius')}
    >
      {t('sign-up.action')}
    </button>
  );
};

LoginButton.propTypes = {
  t: PropTypes.func,
};

export default LoginButton;
